<mat-sidenav-container>
  <!-- for mobile views -->
  <mat-sidenav #sidenav position="end" fixedInViewport="true" *ngIf="mobile.isMobileDisplay()">
    <button class="close-button" (click)="sidenav.close()" data-cy="mobile-menu-close-button">
      <rav-icon [name]="RavIcon.Cancel" class="page__icon"></rav-icon>
    </button>
    <div class="padding-left-2 padding-top-2">
      <h5>{{ localStorage.userWithToken?.first_name }} {{ localStorage.userWithToken?.last_name }}</h5>
      <p class="dark-gray-color">Account ID: {{ localStorage.userWithToken?.account_id }}</p>
    </div>

    <rav-sidebar [logoSrc]="logoSrc" [menus]="sidebarMenus" class="sidebar">
      <ng-content></ng-content>
    </rav-sidebar>
  </mat-sidenav>

  <div class="grid-x align-justify align-middle top-bar hide-for-medium" *ngIf="mobile.isMobileDisplay()">
    <div class="cell shrink">
      <a routerLink="/"><img [src]="logoSrc" alt="Raven" width="125" /></a>
    </div>
    <div class="cell shrink">
      <div class="grid-x align-right align-middle">
        <div class="cell shrink">
          <rav-global-search *ngIf="!isAdminPage()"></rav-global-search>
        </div>
        <div class="cell shrink">
          <button class="clear button margin-0" (click)="sidenav.open()" data-cy="mobile-menu-button">
            <i class="fa fa-bars fa-2x"></i>
          </button>
        </div>
      </div>
    </div>
  </div>
  <!-- end mobile views -->
  <div class="grid-x">
    <rav-sidebar
      *ngIf="!mobile.isMobileDisplay()"
      [logoSrc]="logoSrc"
      [menus]="sidebarMenus"
      (collapsed)="onSidebarCollapse($event)"
      class="cell | sidebar"
      [ngClass]="{ 'sidebar--collapsed': isSidebarCollapsed }"
    >
      <ng-content></ng-content>
    </rav-sidebar>
    <rav-content class="cell medium-auto small-12" id="layout-rav-content"></rav-content>
  </div>
</mat-sidenav-container>

<!-- Modals for the new-button. Can't be within the sidebar because its restricted to sidebar width on mobile -->
<rav-import-files *ngIf="!isAdminPage()"></rav-import-files>
<rav-folder-select modalId="createFolders" [isCreateFolders]="true"></rav-folder-select>
<rav-import-manager></rav-import-manager>
